import { Alert, Box, Button, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDemoAppContext } from '../../pages/demo/DemoAppContext';
import './AppClose.css';

interface AppCloseResponse {
  success: boolean;
}

const AppClose = () => {
  const [response, setResponse] = useState<AppCloseResponse | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { client, clientId } = useDemoAppContext();

  const timestamp = new Date().toISOString();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setResponse(null);

    const response = await client.POST('/app-close', {
      body: { clientId },
    });

    if (response.error) {
      setError(response.error ?? 'An error occurred');
      return;
    }

    if (response.data) {
      setResponse(response.data);
    } else {
      // Handle 204 No Content response
      setResponse({ success: true });
    }
  };

  return (
    <Paper elevation={3} className="app-close-paper">
      <Typography variant="h5" component="h2" gutterBottom>
        App Close (POST /app-close)
      </Typography>
      <Typography variant="body2" color="textSecondary">
        This endpoint should be called when the app is closed.
      </Typography>

      <Box className="app-close-info">
        <Typography variant="body2" color="textSecondary">
          Client ID: {clientId}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Timestamp: {timestamp}
        </Typography>
      </Box>

      <form onSubmit={handleSubmit}>
        <Box className="app-close-container">
          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={client.getToken() === ''}
            className="app-close-button"
          >
            Close App
          </Button>
        </Box>
      </form>

      {error && (
        <Alert severity="error" className="app-close-error">
          {error}
        </Alert>
      )}

      {response && (
        <Box className="app-close-response">
          <Typography variant="h6" gutterBottom>
            Response:
          </Typography>
          <Paper variant="outlined" className="app-close-response-paper">
            <pre className="app-close-response-pre">
              {JSON.stringify(response, null, 2)}
            </pre>
          </Paper>
        </Box>
      )}
    </Paper>
  );
};

export default AppClose;
